import { useEffect } from 'react';

const VisitorTracker = () => {
  const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

  const generateSessionId = () => {
    return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  };

  const getOrCreateSessionId = () => {
    let sessionId = sessionStorage.getItem('visitor_session_id');
    if (!sessionId) {
      sessionId = generateSessionId();
      sessionStorage.setItem('visitor_session_id', sessionId);
    }
    return sessionId;
  };

  const trackVisit = async () => {
    try {
      const sessionId = getOrCreateSessionId();
      
      const visitorData = {
        ip_address: 'unknown', // Will be determined by backend
        user_agent: navigator.userAgent,
        page_visited: window.location.pathname,
        referrer: document.referrer || null,
        session_id: sessionId,
        country: null, // Could be enhanced with IP geolocation
        city: null
      };

      await fetch(`${API_BASE}/track/visit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(visitorData)
      });
    } catch (error) {
      console.log('Visitor tracking failed:', error);
    }
  };

  const trackActivity = async (activityType, activityData) => {
    try {
      const sessionId = getOrCreateSessionId();
      
      const activityLog = {
        session_id: sessionId,
        activity_type: activityType,
        activity_data: activityData
      };

      await fetch(`${API_BASE}/track/activity`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(activityLog)
      });
    } catch (error) {
      console.log('Activity tracking failed:', error);
    }
  };

  useEffect(() => {
    // Track initial visit
    trackVisit();

    // Track page clicks
    const handleClick = (event) => {
      trackActivity('click', {
        element: event.target.tagName,
        text: event.target.textContent?.substring(0, 100) || '',
        x: event.clientX,
        y: event.clientY
      });
    };

    // Track scroll depth
    let maxScrollDepth = 0;
    const handleScroll = () => {
      const scrollDepth = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100);
      if (scrollDepth > maxScrollDepth) {
        maxScrollDepth = scrollDepth;
        if (maxScrollDepth % 25 === 0) { // Track at 25%, 50%, 75%, 100%
          trackActivity('scroll', {
            depth: maxScrollDepth,
            page_height: document.body.scrollHeight,
            viewport_height: window.innerHeight
          });
        }
      }
    };

    // Track time spent on page
    const startTime = Date.now();
    const handleBeforeUnload = () => {
      const timeSpent = Date.now() - startTime;
      trackActivity('time_spent', {
        duration_ms: timeSpent,
        duration_readable: Math.round(timeSpent / 1000) + ' seconds'
      });
    };

    // Add event listeners
    document.addEventListener('click', handleClick);
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup
    return () => {
      document.removeEventListener('click', handleClick);
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default VisitorTracker;